export enum Environment {
    "local" = 'header.environment.local',
    "dev" = 'header.environment.dev',
    "acc" = 'header.environment.acc'
}
